import { jsx as f } from "react/jsx-runtime";
import { memo as R, useMemo as u } from "react";
import "../../../node_modules/@perxis-auto/shared/lib/lib/async/hooks/useAsync.js";
import "../../../node_modules/markdown-it/lib/rules_core/state_core.js";
import "../../../node_modules/markdown-it/lib/rules_block/state_block.js";
import "../../../node_modules/markdown-it/lib/rules_block/html_block.js";
import "../../../node_modules/markdown-it/lib/rules_inline/state_inline.js";
import "../../../node_modules/markdown-it/lib/rules_inline/escape.js";
import { LoadingEnum as g } from "../../../node_modules/@perxis-auto/shared/lib/types/utility/async.js";
import { useField as y } from "@perxis-auto/trade-in-sdk";
import { RuleId as a, WidgetType as l } from "@perxis-auto/trade-in-sdk/types";
import { Form as N } from "@perxis-auto/ui-kit/lib/components/Form";
import { FIELD_ELEMENT_VALUE as m } from "./Field.types.js";
import { FieldElement as H } from "./FieldElement.js";
const K = R(function({ fieldId: c, formId: b }) {
  const {
    data: r,
    options: n = [],
    loading: _,
    disabled: v
  } = y({ id: c, formId: b }), E = [g.Idle, g.Pending].includes(_), T = u(() => {
    var d;
    if (!r)
      return;
    const t = [];
    return r.required && t.push({
      required: !0,
      message: "Поле обязательно для заполнения"
    }), (d = r.rules) == null || d.forEach((e) => {
      if (!e.id || typeof e.value > "u")
        return;
      const i = e.error_message ?? "Некорректное значение";
      switch (e.id) {
        case a.MIN_LENGTH: {
          typeof e.value == "number" && t.push({
            min: e.value,
            message: i
          });
          break;
        }
        case a.MAX_LENGTH: {
          typeof e.value == "number" && t.push({
            max: e.value,
            message: i
          });
          break;
        }
        case a.GREATER_THAN:
        case a.GREATER_THAN_OR_EQUAL: {
          if (typeof e.value == "number") {
            const o = e.value;
            t.push(() => ({
              validator(p, s) {
                return typeof s > "u" || (e.id === a.GREATER_THAN_OR_EQUAL ? s >= o : s > o) ? Promise.resolve() : Promise.reject(new Error(i));
              }
            }));
          }
          break;
        }
        case a.LESS_THAN:
        case a.LESS_THAN_OR_EQUAL: {
          if (typeof e.value == "number") {
            const o = e.value;
            t.push(() => ({
              validator(p, s) {
                return typeof s > "u" || (e.id === a.LESS_THAN_OR_EQUAL ? s <= o : s < o) ? Promise.resolve() : Promise.reject(new Error(i));
              }
            }));
          }
          break;
        }
        case a.PATTERN: {
          t.push({
            pattern: e.value,
            message: i
          });
          break;
        }
      }
    }), t;
  }, [r]), h = u(() => {
    if (!(!n || !n.length || !(r != null && r.widget)))
      switch (r.widget) {
        case l.SELECT:
        case l.AUTOCOMPLETE: {
          if (!r.group_by)
            return n.map((e) => ({
              label: e.text,
              value: e.id,
              [m]: e
            }));
          const t = (e, i) => i.split(".").reduce((o, p) => o && o[p], e), d = /* @__PURE__ */ new Map();
          return n.forEach((e) => {
            const i = t(e, r.group_by), o = d.get(i) || [];
            return d.set(i, [
              ...o,
              {
                label: e.text,
                value: e.id,
                [m]: e
              }
            ]);
          }), [...d].map(([e, i]) => ({
            label: e,
            options: i.sort((o, p) => o.label.localeCompare(p.label))
          }));
        }
        case l.RADIO:
          return n.map((t) => ({
            label: t.text,
            value: t.id,
            [m]: t
          }));
        default:
          return;
      }
  }, [r, n]), A = u(() => {
    if (r != null && r.widget)
      switch (r.widget) {
        case l.CHECKBOX:
          return { children: r.label };
        default:
          return;
      }
  }, [r]);
  if (!(r != null && r.type))
    return null;
  const L = l.CHECKBOX === r.widget ? "checked" : void 0, w = l.CHECKBOX !== r.widget ? r.label : void 0;
  return /* @__PURE__ */ f(
    N.Item,
    {
      name: c,
      label: w,
      loading: E,
      required: r.required,
      rules: T,
      dependencies: r.depends,
      valuePropName: L,
      children: /* @__PURE__ */ f(
        H,
        {
          ...A,
          widgetType: r.widget,
          disabled: v,
          loading: E,
          options: h,
          placeholder: r.placeholder ?? void 0
        }
      )
    }
  );
});
export {
  K as Field
};
